import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { reportClientError } from './services/api';

// ============================================================================
// GLOBAL ERROR HANDLERS - Report uncaught errors to MetrikkAPI
// ============================================================================

window.addEventListener('error', (event) => {
  const { message, filename, lineno, colno, error } = event;
  
  // Skip errors from extensions or external scripts
  if (filename && !filename.includes(window.location.origin)) {
    return;
  }
  
  reportClientError({
    severity: 'error',
    errorCode: 'UNCAUGHT_ERROR',
    message: message || 'Unknown error',
    meta: {
      filename,
      lineno,
      colno,
      stack: error?.stack,
      url: window.location.href,
    },
  });
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const message = reason instanceof Error ? reason.message : String(reason);
  const stack = reason instanceof Error ? reason.stack : undefined;
  
  reportClientError({
    severity: 'error',
    errorCode: 'UNHANDLED_PROMISE_REJECTION',
    message: message || 'Unhandled promise rejection',
    meta: {
      stack,
      url: window.location.href,
    },
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
